// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable */
(function (window, factory) {
    var ezSelector = factory(window, window.document, Date);
    window.ezSelector = ezSelector;
    if (typeof module == "object" && module.exports) {
        module.exports = ezSelector;
    }
})(typeof window != "undefined" ? window : {}, function l(window, document, Date) {
    window.cnsOverlayOpen = cnsOverlayOpen;
    window.cnsOverlayClose = cnsOverlayClose;
    window.cnsOverlayZIndex = 1e4;
    window.cnsOverlayMargin = 4;
    window.cnsTwoColumnView = !0;
    window.cnsCloseButton = !0;
    window.cnsLanguage = "";
    function cnsUrlPath() {
        return "//ezlist.schneider-electric.com/";
    }
    function cnsOverlayOpen(d, e) {
        let b = cnsOverlayNextHighZIndex("div");
        cnsCheckOverlayMargin();
        if (document.getElementById("cnsOverlayWrapper") === null) {
            var a = document.createElement("div");
            a.style.cssText = `position:fixed;width:100%;height:100%;top:0px;left:0px;display:none;z-index:${b};`;
            a.id = "cnsOverlayWrapper";
            document.body.appendChild(a);
            b += 1;
        }
        a = "";
        typeof window.cnsLabelAddToList === "string" && (a += `&button=${window.cnsLabelAddToList}`);
        a =
            !1 === window.cnsCloseButton
                ? `${a}&close=false`
                : !0 === window.cnsCloseButton
                ? `${a}&close=true`
                : `${a}&close=${window.cnsCloseButton}`;
        typeof e !== "undefined" && (a += `&subset=${e}`);
        typeof window.cnsLanguage === "string" && window.cnsLanguage != "" && (a += `&lang=${cnsLanguage}`);
        typeof window.cnsInitialHost === "string" && (a += `&ihost=${window.cnsInitialHost}`);
        typeof window.cnsDist !== "undefined" && window.cnsDist != "" && (a += `&dist=${window.cnsDist}`);
        let c = location.protocol;
        c == "file:" && (c = "http:");
        document.getElementById(
            "cnsOverlayWrapper",
        ).innerHTML = `<div style="position:fixed;width:100%;height:100%;top:0px;left:0px;opacity:0.5;z-index:${
            b + 1
        };background:#000;"></div><div style="position:fixed;width:${100 - 2 * window.cnsOverlayMargin}%;height:${
            100 - 2 * window.cnsOverlayMargin
        }%;top:${window.cnsOverlayMargin}%;left:${window.cnsOverlayMargin}%;z-index:${
            b + 2
        };background:#fff;"><iframe width="100%" height="100%" style="border-width:0;background-color:#cccccc;display:block;" src="${c}${cnsUrlPath()}cnst.php?prod=${d}&apiKey=${
            window.cnsHostID
        }&col2=${window.cnsTwoColumnView}${a}"></iframe></div>`;
        document.getElementById("cnsOverlayWrapper").style.display = "block";
    }
    function cnsOverlayClose() {
        console.log("cnsOverlayClose()");
        document.getElementById("cnsOverlayWrapper").style.display = "none";
        document.getElementById("cnsOverlayWrapper").innerHTML = "";
    }
    function cnsCheckOverlayMargin() {
        typeof window.cnsOverlayMargin !== "number"
            ? (window.cnsOverlayMargin = 4)
            : window.cnsOverlayMargin > 25
            ? (window.cnsOverlayMargin = 25)
            : window.cnsOverlayMargin < 0 && (window.cnsOverlayMargin = 0);
    }
    function cnsOverlayNextHighZIndex(d) {
        window.cnsOverlayZIndex < 1e4 && (window.cnsOverlayZIndex = 1e4);
        return window.cnsOverlayZIndex;
    }

    var ezSelector = {
        cnsOverlayOpen,
        cnsOverlayClose,
    };

    return ezSelector;
});
